"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const faqs = [{
  question: "What documents do I need for a mortgage application?",
  answer: "Typically, you will need proof of identity, recent pay stubs, tax returns from the last two years, and bank statements. Our advisors provide a personalized checklist to ensure your application is precise and complete."
}, {
  question: "How much down payment is required for first-time buyers?",
  answer: "While 20% is traditional, many first-time buyer programs allow for as little as 3% to 5% down. We help you explore various loan options to find the one that best fits your financial strategy."
}, {
  question: "What is the difference between a fixed-rate and adjustable-rate mortgage?",
  answer: "A fixed-rate mortgage maintains the same interest rate for the life of the loan, providing stability. An adjustable-rate mortgage (ARM) typically starts with a lower rate that may change over time based on market conditions."
}, {
  question: "How long does the mortgage approval process take?",
  answer: "The timeline varies, but most applications are processed within 30 to 45 days. We utilize streamlined digital tools to accelerate verification and keep your path to ownership moving forward efficiently."
}, {
  question: "Can I get pre-approved before I start house hunting?",
  answer: "Absolutely. A pre-approval letter from Premier Home Loans strengthens your position as a buyer and gives you a clear understanding of your budget before you begin your search."
}];
export default function CommonQuestions() {
  return <section data-section-id="238773" id="common-questions" className="bg-background py-24 px-6 relative overflow-hidden">
      {}
      <style>{`
        @keyframes borderPulse {
          0%, 100% { border-left-color: var(--secondary); }
          50% { border-left-color: color-mix(in srgb, var(--secondary) 20%, transparent); }
        }
        .active-pulse[data-state="open"] {
          animation: borderPulse 2s ease-in-out infinite;
        }
      `}</style>

      <div className="max-w-[800px] mx-auto relative z-10">
        <div className="mb-16 text-center">
          <h2 className="text-4xl md:text-5xl font-default font-bold text-foreground tracking-tight mb-4">
            Common Questions
          </h2>
          <p className="text-muted-foreground font-sans text-lg max-w-2xl mx-auto">
            Clear answers to help you navigate the complexities of home financing with confidence.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="group/item !border !border-border !border-l-[3px] !border-l-transparent data-[state=open]:!border-l-secondary bg-card !rounded-md active-pulse transition-colors duration-300 shadow-sm">
              <AccordionTrigger className="group [&>svg]:hidden bg-card !px-6 !py-5 hover:no-underline !rounded-md">
                <span className="font-default text-foreground group-hover:text-secondary transition-colors text-lg md:text-xl font-bold text-left pr-4">
                  {faq.question}
                </span>
                <div className="font-mono text-secondary text-xl ml-auto shrink-0 flex items-center justify-center w-6 h-6">
                  <span className="group-data-[state=open]:hidden leading-none mt-[-2px]">+</span>
                  <span className="hidden group-data-[state=open]:block leading-none mt-[-2px]">−</span>
                </div>
              </AccordionTrigger>
              <AccordionContent className="!px-6 !py-6 text-muted-foreground font-sans text-base leading-relaxed bg-card">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}